import api from "../../Api/feathers-client";

// Call backend service to create users
export const createProjects = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("projects").create(data, {});
      resolve({
        status: 201,
        message: "Project Created",
        data: response,
      });
    } catch (error) {
      console.log("error===>",error);
      resolve(error);
    }
  });
};

// Call backend service to update users
export const updateProjects = async (data, uid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("projects").patch(null, data, {
        query: {
          uid
        },
      });

      resolve({
        status: 201,
        message: "Project Updated",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getProjectsDb = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("projects").find(params);
      resolve({
        status: 201,
        message: "Projects List",
        data: response,
      });
    } catch (error) {
      console.log("error==>", error);
      resolve(error);
    }
  });
};

export const getProjectOptions = async (params) => {  
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("project-options").find(params);
      resolve({
        status: 201,
        message: "Projects Options",
        data: response.data,
      });
    } catch (error) {
      console.log("error==>", error);
      resolve(error);
    }
  });
};

export const getFilteredByProjects = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("get-filtered-by-project").find(params);
      // console.log("response===>", response);
      resolve({
        status: 201,
        message: "Projects List",
        data: response,
      });
    } catch (error) {
      console.log("error==>", error);
      resolve(error);
    }
  });
};